import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import Team from "../components/Team"
import Values from "../components/Values"
import PageHead from "../components/PageHead"
import PreviewCompatibleImage from "../components/PreviewCompatibleImage"

export const Head = ({ data }) => (
  <PageHead
    title={data.markdownRemark.frontmatter.mainpitch.title}
    description={data.markdownRemark.frontmatter.mainpitch.description}
  />
)

export const AboutPageTemplate = ({
  title,
  image,
  values,
  mainpitch,
  team,
  advisors,
  items: steps,
}) => {
  return (
    <section className="about-page">
      <h1 className="h2 center spacing-l">{title}</h1>
      <PreviewCompatibleImage
        imageInfo={image}
        className="team-image spacing-l"
      />
      <Team title="Meet the Team" teamMembers={team} className="spacing-l" />
      <Team
        title="Meet our Advisors"
        teamMembers={advisors}
        className="spacing-l"
      />
      <Values values={values} />
    </section>
  )
}

const AboutPage = ({ data }) => {
  const { markdownRemark: post } = data

  return (
    <Layout>
      <AboutPageTemplate {...post.frontmatter} />
    </Layout>
  )
}

export default AboutPage

export const aboutPageQuery = graphql`
  query AboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        image {
          childImageSharp {
            gatsbyImageData(quality: 100, width: 1136, height: 757)
          }
        }
        mainpitch {
          title
          subtitle
          description
        }
        items {
          title
          description
        }
        team {
          name
          jobTitle
          description
          image {
            childImageSharp {
              gatsbyImageData(quality: 100, width: 768, height: 768)
            }
          }
        }
        advisors {
          name
          jobTitle
          description
          image {
            childImageSharp {
              gatsbyImageData(quality: 100, width: 768, height: 768)
            }
          }
        }
        values {
          title
          description
          icon
        }
      }
    }
  }
`
